import React from 'react';

import { Table, ITableProps } from './src/table';

const TableExample = (props: ITableProps): JSX.Element => (
    <Table {...props} />
);

export default TableExample;
